import { createSelector } from 'reselect';
import property from 'lodash/property';
import getDialogProperties from './getDialogProperties';
import { RootState } from '../../../stores/types';

export default <T>(dialogName: string, dialogProp: string) => createSelector<RootState, any, T>(
  getDialogProperties(dialogName),
  property(dialogProp),
);
